import { GeoJson } from '@ais-ui/api-spec/shapes';

export const getShapeType = (shape: GeoJson): string => {
  if (shape.type === 'FeatureCollection') {
    return 'FeatureCollection';
  } else {
    switch (shape.geometry?.type) {
      case 'Point':
        return shape.properties?.radius ? 'Circle' : 'Point';
      case 'Polygon':
        return 'Polygon';
      case 'LineString':
        return 'LineString';
      default:
        return 'Unknown';
    }
  }
};
